import { observable, action } from 'mobx';

export class AddressMapUiState {
    @observable public latLng: { [key: string]: { lat: number | null, lng: number | null } } = {}

    @action
    public setLatLng(key: string, latLng: { lat: number | null, lng: number | null }) {
        this.latLng[key] = latLng;
    }
}